import React from 'react';
import SwitchRow from './SwitchRow';
import { choice } from './choiceStyles';
import { MAX_HOURS } from '../../../utils/orderHourly';
import { COLORS } from '../../../styles/tokens';

// Timepris: bestiller betaler per time (heldag) i stedet for per lass. value: { on, hours }.
export default function HourlyPicker({ value, onChange, max = MAX_HOURS }) {
  const step = (d) => onChange({ on: true, hours: Math.min(max, Math.max(1, value.hours + d)) });
  return (
    <div style={{ ...choice.card, padding: '4px 14px 12px' }}>
      <SwitchRow
        title="Betal per time" sub="Bestill kjøring for et antall timer i stedet for per lass"
        checked={value.on} onChange={on => onChange({ on, hours: value.hours })}
      />
      {value.on && (
        <>
          <div style={choice.divider} />
          <div style={styles.row}>
            <span style={choice.label}>Antall timer</span>
            <div style={styles.stepper}>
              <button type="button" aria-label="Færre timer" style={styles.btn} disabled={value.hours <= 1} onClick={() => step(-1)}>−</button>
              <span style={styles.count}>{value.hours}</span>
              <button type="button" aria-label="Flere timer" style={styles.btn} disabled={value.hours >= max} onClick={() => step(1)}>+</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

const styles = {
  row:     { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  stepper: { display: 'flex', alignItems: 'center', gap: 12 },
  btn:     { width: 40, height: 40, borderRadius: 99, border: `1px solid ${COLORS.border}`, background: COLORS.white, color: COLORS.textDark, fontSize: 20, fontWeight: 700, cursor: 'pointer' },
  count:   { minWidth: 24, textAlign: 'center', fontSize: 20, fontWeight: 700, color: COLORS.textDark },
};
